var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGwConnectionInstructions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 370.341,
    height: 189.77,
    viewBox: "0 0 370.341 189.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c5b77",
    stopOpacity: 0.655
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1,
    y1: 0.544,
    x2: 0,
    y2: 0.546,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998",
    transform: "translate(-166.757 -727.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616",
    transform: "translate(154.564 727.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_22",
    "data-name": "Union 22",
    transform: "translate(89.314 0)",
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 207.3122863769531 166.2020111083984 L 50.02289199829102 166.2020111083984 C 47.81709289550781 166.2020111083984 46.02252578735352 164.4078369140625 46.02252578735352 162.2024993896484 L 46.02252578735352 156.7458038330078 L 46.02252578735352 155.7458038330078 L 45.02252578735352 155.7458038330078 L 5.000393390655518 155.7458038330078 C 2.794559955596924 155.7458038330078 0.9999933838844299 153.9512329101562 0.9999933838844299 151.7454071044922 L 0.9999933838844299 4.999505519866943 C 0.9999933838844299 2.794172286987305 2.794559955596924 1.000005602836609 5.000393390655518 1.000005602836609 L 252.3339233398438 1.000005602836609 C 254.5397644042969 1.000005602836609 256.3343200683594 2.794172286987305 256.3343200683594 4.999505519866943 L 256.3343200683594 151.7454071044922 C 256.3343200683594 153.9512329101562 254.5397644042969 155.7458038330078 252.3339233398438 155.7458038330078 L 212.3117980957031 155.7458038330078 L 211.3117980957031 155.7458038330078 L 211.3117980957031 156.7458038330078 L 211.3117980957031 162.2024993896484 C 211.3117980957031 164.4078369140625 209.5176239013672 166.2020111083984 207.3122863769531 166.2020111083984 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 207.3122863769531 165.2020111083984 C 208.9662322998047 165.2020111083984 210.3117980957031 163.8564453125 210.3117980957031 162.2024993896484 L 210.3117980957031 154.7458038330078 L 252.3339233398438 154.7458038330078 C 253.9883575439453 154.7458038330078 255.3343200683594 153.3998413085938 255.3343200683594 151.7454071044922 L 255.3343200683594 4.999505519866943 C 255.3343200683594 3.345572233200073 253.9883575439453 2.000005483627319 252.3339233398438 2.000005483627319 L 5.000393390655518 2.000005483627319 C 3.345960140228271 2.000005483627319 1.999993324279785 3.345572233200073 1.999993324279785 4.999505519866943 L 1.999993324279785 151.7454071044922 C 1.999993324279785 153.3998413085938 3.345960140228271 154.7458038330078 5.000393390655518 154.7458038330078 L 47.02252578735352 154.7458038330078 L 47.02252578735352 162.2024993896484 C 47.02252578735352 163.8564453125 48.36849212646484 165.2020111083984 50.02289199829102 165.2020111083984 L 207.3122863769531 165.2020111083984 M 207.3122863769531 167.2020111083984 L 50.02289199829102 167.2020111083984 C 47.26079177856445 167.2020111083984 45.02252578735352 164.9636993408203 45.02252578735352 162.2024993896484 L 45.02252578735352 156.7458038330078 L 5.000393390655518 156.7458038330078 C 2.239193439483643 156.7458038330078 -6.632486929447623e-06 154.5075073242188 -6.632486929447623e-06 151.7454071044922 L -6.632486929447623e-06 4.999505519866943 C -6.632486929447623e-06 2.238305568695068 2.239193439483643 5.554199105972657e-06 5.000393390655518 5.554199105972657e-06 L 252.3339233398438 5.554199105972657e-06 C 255.0960235595703 5.554199105972657e-06 257.3343200683594 2.238305568695068 257.3343200683594 4.999505519866943 L 257.3343200683594 151.7454071044922 C 257.3343200683594 154.5075073242188 255.0960235595703 156.7458038330078 252.3339233398438 156.7458038330078 L 212.3117980957031 156.7458038330078 L 212.3117980957031 162.2024993896484 C 212.3117980957031 164.9636993408203 210.073486328125 167.2020111083984 207.3122863769531 167.2020111083984 Z",
    stroke: "none",
    fill: "#4c5b77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_617",
    "data-name": "Rectangle 617",
    transform: "translate(96.779 7.108)",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 242.406,
    height: 142.529,
    rx: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 240.406,
    height: 140.529,
    rx: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964",
    transform: "translate(111.881 114.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_618",
    "data-name": "Rectangle 618",
    transform: "translate(0.008 0)",
    stroke: "#4c5b77",
    strokeWidth: 2,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 208.888,
    height: 28.88,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 206.888,
    height: 26.88,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963",
    transform: "translate(14.842 6.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_465",
    "data-name": "Path 465",
    transform: "translate(0.167)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 33.05530548095703 15.34993743896484 L 4.976066112518311 15.34993743896484 C 3.371616125106812 15.34993743896484 2.066296100616455 14.04461765289307 2.066296100616455 12.44016742706299 L 2.066296100616455 12.37790775299072 L 2.058576107025146 12.31613731384277 L 1.000561356544495 3.852020502090454 C 1.03143036365509 2.274112939834595 2.324607849121094 0.9999977946281433 3.909765958786011 0.9999977946281433 L 34.12160491943359 0.9999977946281433 C 35.70676422119141 0.9999977946281433 36.99994277954102 2.27410364151001 37.03081130981445 3.852011203765869 L 35.97278594970703 12.31612777709961 L 35.96506500244141 12.37790775299072 L 35.96506500244141 12.44016742706299 C 35.96506500244141 14.04461765289307 34.65975570678711 15.34993743896484 33.05530548095703 15.34993743896484 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.909767150878906 1.999998092651367 C 2.891166687011719 1.999998092651367 2.056262969970703 2.80156135559082 2.002723693847656 3.807051658630371 L 3.066295623779297 12.31564712524414 L 3.066295623779297 12.44016742706299 C 3.066295623779297 13.49321746826172 3.923015594482422 14.34993743896484 4.976066589355469 14.34993743896484 L 33.05530548095703 14.34993743896484 C 34.10835647583008 14.34993743896484 34.96506500244141 13.49321746826172 34.96506500244141 12.44016742706299 L 34.96506500244141 12.31564712524414 L 36.02864837646484 3.807050704956055 C 35.9751091003418 2.801560401916504 35.14020538330078 1.999998092651367 34.12159729003906 1.999998092651367 L 3.909767150878906 1.999998092651367 M 3.909767150878906 -1.9073486328125e-06 L 34.12159729003906 -1.9073486328125e-06 C 36.28090667724609 -1.9073486328125e-06 38.03137588500977 1.750457763671875 38.03137588500977 3.909768104553223 L 36.96506500244141 12.44016742706299 C 36.96506500244141 14.59946823120117 35.21460723876953 16.34993743896484 33.05530548095703 16.34993743896484 L 4.976066589355469 16.34993743896484 C 2.816757202148438 16.34993743896484 1.066295623779297 14.59946823120117 1.066295623779297 12.44016742706299 L -3.814697265625e-06 3.909768104553223 C -3.814697265625e-06 1.750457763671875 1.750457763671875 -1.9073486328125e-06 3.909767150878906 -1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#4c5b77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    transform: "translate(9.167 3.065)",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.777,
    cy: 1.777,
    r: 1.777,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.777,
    cy: 1.777,
    r: 0.777,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_250",
    "data-name": "Ellipse 250",
    transform: "translate(3.167 3.065)",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.777,
    cy: 1.777,
    r: 1.777,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.777,
    cy: 1.777,
    r: 0.777,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    transform: "translate(21.167 3.065)",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.777,
    cy: 1.777,
    r: 1.777,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.777,
    cy: 1.777,
    r: 0.777,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    transform: "translate(15.167 3.065)",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.777,
    cy: 1.777,
    r: 1.777,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.777,
    cy: 1.777,
    r: 0.777,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    transform: "translate(27.167 3.065)",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.777,
    cy: 1.777,
    r: 1.777,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.777,
    cy: 1.777,
    r: 0.777,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    transform: "translate(8.167 9.497)",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.777,
    cy: 1.777,
    r: 1.777,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.777,
    cy: 1.777,
    r: 0.777,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    transform: "translate(19.167 9.497)",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.777,
    cy: 1.777,
    r: 1.777,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.777,
    cy: 1.777,
    r: 0.777,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    transform: "translate(14.167 9.497)",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.777,
    cy: 1.777,
    r: 1.777,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.777,
    cy: 1.777,
    r: 0.777,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    transform: "translate(25.167 9.497)",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.777,
    cy: 1.777,
    r: 1.777,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.777,
    cy: 1.777,
    r: 0.777,
    fill: "none"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_967",
    "data-name": "Group 967",
    transform: "translate(108.508 105.208) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_634",
    "data-name": "Rectangle 634",
    transform: "translate(0)",
    stroke: "#4c5b77",
    strokeWidth: 2,
    fill: "url(#linear-gradient-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.171,
    height: 43.007,
    rx: 21.504,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 81.171,
    height: 41.007,
    rx: 20.504,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965",
    transform: "translate(14.573 14.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_22",
    "data-name": "Subtraction 22",
    transform: "translate(0 0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.9705753326416 19.61513710021973 L 1.000004768371582 19.61513710021973 L 1.000004768371582 6.975427627563477 L 4.102844715118408 6.975427627563477 L 5.102844715118408 6.975427627563477 L 5.102844715118408 5.975427627563477 L 5.102844715118408 4.286567687988281 L 6.154404640197754 4.286567687988281 L 7.154404640197754 4.286567687988281 L 7.154404640197754 3.286567687988281 L 7.154404640197754 0.999997615814209 L 13.81615447998047 0.999997615814209 L 13.81615447998047 3.286567687988281 L 13.81615447998047 4.286567687988281 L 14.81615447998047 4.286567687988281 L 15.86744499206543 4.286567687988281 L 15.86744499206543 5.975427627563477 L 15.86744499206543 6.975427627563477 L 16.86744499206543 6.975427627563477 L 19.9705753326416 6.975427627563477 L 19.9705753326416 19.61513710021973 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.9705753326416 18.61513710021973 L 18.9705753326416 7.975427627563477 L 14.86744499206543 7.975427627563477 L 14.86744499206543 5.286567687988281 L 12.81615447998047 5.286567687988281 L 12.81615447998047 1.999997615814209 L 8.154404640197754 1.999997615814209 L 8.154404640197754 5.286567687988281 L 6.102844715118408 5.286567687988281 L 6.102844715118408 7.975427627563477 L 2.000004768371582 7.975427627563477 L 2.000004768371582 18.61513710021973 L 18.9705753326416 18.61513710021973 M 20.9705753326416 20.61513710021973 L 4.805297976417933e-06 20.61513710021973 L 4.805297976417933e-06 5.975427627563477 L 4.102844715118408 5.975427627563477 L 4.102844715118408 3.286567687988281 L 6.154404640197754 3.286567687988281 L 6.154404640197754 -2.403564394626301e-06 L 14.81615447998047 -2.403564394626301e-06 L 14.81615447998047 3.286567687988281 L 16.86744499206543 3.286567687988281 L 16.86744499206543 5.975427627563477 L 20.9705753326416 5.975427627563477 L 20.9705753326416 20.61513710021973 Z",
    stroke: "none",
    fill: "#4c5b77"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_966",
    "data-name": "Group 966",
    transform: "translate(45.496 7.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_22-2",
    "data-name": "Subtraction 22",
    transform: "translate(0 0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.9705753326416 19.25970077514648 L 1.000004768371582 19.25970077514648 L 1.000004768371582 6.872411251068115 L 4.102844715118408 6.872411251068115 L 5.102844715118408 6.872411251068115 L 5.102844715118408 5.872411251068115 L 5.102844715118408 4.229941368103027 L 6.154404640197754 4.229941368103027 L 7.154404640197754 4.229941368103027 L 7.154404640197754 3.229941368103027 L 7.154404640197754 1.000001311302185 L 13.81615447998047 1.000001311302185 L 13.81615447998047 3.229941368103027 L 13.81615447998047 4.229941368103027 L 14.81615447998047 4.229941368103027 L 15.86744499206543 4.229941368103027 L 15.86744499206543 5.872411251068115 L 15.86744499206543 6.872411251068115 L 16.86744499206543 6.872411251068115 L 19.9705753326416 6.872411251068115 L 19.9705753326416 19.25970077514648 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.9705753326416 18.25970077514648 L 18.9705753326416 7.872411251068115 L 14.86744499206543 7.872411251068115 L 14.86744499206543 5.229941368103027 L 12.81615447998047 5.229941368103027 L 12.81615447998047 2.000001430511475 L 8.154404640197754 2.000001430511475 L 8.154404640197754 5.229941368103027 L 6.102844715118408 5.229941368103027 L 6.102844715118408 7.872411251068115 L 2.000004768371582 7.872411251068115 L 2.000004768371582 18.25970077514648 L 18.9705753326416 18.25970077514648 M 20.9705753326416 20.25970077514648 L 4.805297976417933e-06 20.25970077514648 L 4.805297976417933e-06 5.872411251068115 L 4.102844715118408 5.872411251068115 L 4.102844715118408 3.229941368103027 L 6.154404640197754 3.229941368103027 L 6.154404640197754 1.341247525488143e-06 L 14.81615447998047 1.341247525488143e-06 L 14.81615447998047 3.229941368103027 L 16.86744499206543 3.229941368103027 L 16.86744499206543 5.872411251068115 L 20.9705753326416 5.872411251068115 L 20.9705753326416 20.25970077514648 Z",
    stroke: "none",
    fill: "#4c5b77"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_974",
    "data-name": "Group 974",
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 164.465, 125.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M56.979,45.3S54.584,24.307,0,0",
    transform: "translate(5.241 6.461)",
    fill: "none",
    stroke: "#2681c1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M5.213-.079-.193,8.932l7.838,4.78",
    transform: "translate(11.583 0) rotate(45)",
    fill: "none",
    stroke: "#2681c1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_973",
    "data-name": "Group 973",
    transform: "matrix(0.993, -0.122, 0.122, 0.993, 4.792, 42.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_27",
    "data-name": "Subtraction 27",
    d: "M-6055.182-5262.888a3.645,3.645,0,0,1-1.458-.3,185.423,185.423,0,0,1-23.156-12.646l.27-2.2a184.445,184.445,0,0,0,23.681,13.01,1.646,1.646,0,0,0,.662.138,1.663,1.663,0,0,0,1.528-1,1.67,1.67,0,0,0-.866-2.192c-.026-.011-3.532-1.547-8.943-4.431-3.608-1.923-9.246-5.084-15.609-9.219l.271-2.211c6.6,4.333,12.494,7.647,16.277,9.665,5.1,2.716,8.431,4.2,8.794,4.36l.007,0a3.671,3.671,0,0,1,1.9,4.821A3.663,3.663,0,0,1-6055.182-5262.888Z",
    transform: "translate(6087 5286)",
    fill: "#4c5b77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_491",
    "data-name": "Path 491",
    transform: "translate(35.246 30.656) rotate(-53)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16.98051643371582 36.95652008056641 L 1.783216714859009 29.50105857849121 L 1.026214003562927 1.853736042976379 L 15.13658237457275 1.055201053619385 L 16.98051643371582 36.95652008056641 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.18945407867432 2.110408782958984 L 2.052417755126953 2.797267913818359 L 2.766293525695801 28.86948394775391 L 15.89462184906006 35.30995178222656 L 14.18945407867432 2.110408782958984 M 16.08370018005371 3.814697265625e-06 L 18.0664005279541 38.60308456420898 L 0.8001308441162109 30.13263320922852 L 0 0.9102134704589844 L 16.08370018005371 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#4c5b77"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M12.744,24.182a3.478,3.478,0,0,1-1.71-1.228C10.614,22.16.46,9.385.46,9.385S-.221,4.478.074,3.947a6.036,6.036,0,0,1,2.675-2.3C3.822,1.364,19.5,0,19.5,0a10.093,10.093,0,0,1,2.88,1.442A2.776,2.776,0,0,1,23.241,2.8a3.208,3.208,0,0,1,1.973.1A33.307,33.307,0,0,1,29.152,6.38l-7.875,9.34Z",
    transform: "translate(18.713 13.794)",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_21",
    "data-name": "Union 21",
    d: "M6.882,22.787c-.475-.7-1.587-5.088-2.144-7.371l-.723.348a1.6,1.6,0,0,1-2.14-.736L.162,11.514A1.6,1.6,0,0,1,.9,9.375l.007,0,.007,0L15.845.354A4.5,4.5,0,0,1,17.629,0c.715,0,1.215.187,1.371.509l.017.035.03.024,4.759,3.926a1.6,1.6,0,0,1-.4,1.867,1.525,1.525,0,0,1,.7.639c.37.789,0,8.246,0,8.322l-.718.364V13.573H22.331v2.652l-2.488,1.261V15.706H18.776v2.321l-2.844,1.441V17.127H14.866v2.881l-3.2,1.621V19.26H10.6v2.911L8.262,23.356a.855.855,0,0,1-.364.077A1.237,1.237,0,0,1,6.882,22.787Z",
    transform: "translate(57.71 39.004)",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_490",
    "data-name": "Path 490",
    transform: "translate(38.643 31.733) rotate(34)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.57293701171875 9.441120147705078 L 5.715002536773682 9.441120147705078 L 1.012232184410095 8.323168754577637 L 1.124328255653381 1.037437677383423 L 25.7547550201416 1.957043051719666 L 27.10174369812012 4.600659847259521 L 27.38773345947266 5.161940097808838 L 28.01748275756836 5.146359920501709 L 33.58322906494141 5.008701801300049 L 36.57293701171875 9.441120147705078 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.108482360839844 2.074885368347168 L 2.024459838867188 7.535929679870605 L 5.832233428955078 8.441120147705078 L 34.69221115112305 8.441120147705078 L 33.06045532226562 6.021943092346191 L 26.78271293640137 6.177209854125977 L 25.13044166564941 2.934436798095703 L 2.108482360839844 2.074885368347168 M 0.1401748657226562 0 L 26.37908363342285 0.9796600341796875 L 27.99275207519531 4.146669864654541 L 34.10601425170898 3.99547004699707 L 38.45366287231445 10.44112014770508 L 5.597763061523438 10.44112014770508 L 3.814697265625e-06 9.110409736633301 L 0.1401748657226562 0 Z",
    stroke: "none",
    fill: "#4c5b77"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M13.636,30.622,9.715,28.491,7.6,16.47s.915-5.039,3.913-5.431,4.648-.4,8.785,1.554,12.579-.276,12.074-3.766S25.157,0,25.157,0,1.925,6.707.592,8.827s0,12.1,0,12.1,6.9,6.86,9.484,8.494S13.636,30.622,13.636,30.622Z",
    transform: "translate(30.891 17.172)",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M17.548,0,0,9.894",
    transform: "translate(64.09 44.719)",
    fill: "none",
    stroke: "#4c5b77",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M14.416,0S1.718,5.307.829,5.768,0,7.289,0,8.821v2.164",
    transform: "translate(27.417 16.727)",
    fill: "none",
    stroke: "#4c5b77",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M.26,8.845s-1.02-3.09.983-4.208S15.272,0,15.272,0",
    transform: "translate(21.848 13.886)",
    fill: "none",
    stroke: "#4c5b77",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996",
    transform: "translate(251.969 18.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.621,
    height: 85.038,
    rx: 2.31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 2.621,
    height: 83.038,
    rx: 1.31,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_993",
    "data-name": "Group 993",
    transform: "translate(239.349 18.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_635-2",
    "data-name": "Rectangle 635",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.621,
    height: 85.038,
    rx: 2.31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 2.621,
    height: 83.038,
    rx: 1.31,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_992",
    "data-name": "Group 992",
    transform: "translate(226.728 18.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_635-3",
    "data-name": "Rectangle 635",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.621,
    height: 85.038,
    rx: 2.31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 2.621,
    height: 83.038,
    rx: 1.31,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_991",
    "data-name": "Group 991",
    transform: "translate(214.108 18.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_635-4",
    "data-name": "Rectangle 635",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.621,
    height: 85.038,
    rx: 2.31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 2.621,
    height: 83.038,
    rx: 1.31,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_990",
    "data-name": "Group 990",
    transform: "translate(201.487 18.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_635-5",
    "data-name": "Rectangle 635",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.621,
    height: 85.038,
    rx: 2.31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 2.621,
    height: 83.038,
    rx: 1.31,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_989",
    "data-name": "Group 989",
    transform: "translate(188.866 18.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_635-6",
    "data-name": "Rectangle 635",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.621,
    height: 85.038,
    rx: 2.31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 2.621,
    height: 83.038,
    rx: 1.31,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_976",
    "data-name": "Group 976",
    transform: "translate(176.246 18.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_635-7",
    "data-name": "Rectangle 635",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.621,
    height: 85.038,
    rx: 2.31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 2.621,
    height: 83.038,
    rx: 1.31,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_986",
    "data-name": "Group 986",
    transform: "translate(277.552 14.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    transform: "translate(0 82.105) rotate(-90)",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.105,
    height: 42.297,
    rx: 21.148,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 80.105,
    height: 40.297,
    rx: 20.148,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_972",
    "data-name": "Group 972",
    transform: "matrix(0.309, -0.951, 0.951, 0.309, 233.229, 159.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997",
    transform: "translate(0 2.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M7.215,40.084l.006-.007A43.293,43.293,0,0,0,11.845,33.3C15.182,26.536,15.774,9.137,15.72,3a2.978,2.978,0,0,1,2.953-3H18.7a2.977,2.977,0,0,1,2.977,2.953c.008.958.155,23.572-4.489,32.979a48.16,48.16,0,0,1-5.26,7.794C6.729,50.454,2.244,46.517,7.215,40.084Z",
    transform: "translate(20.761 80.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M-6396.865-5284.973h0a14.232,14.232,0,0,1-.376-1.651,14.42,14.42,0,0,1,.543-6.8c1.312-4.19,4.172-7.891,6.695-11.155l.005-.008.005-.007a42.613,42.613,0,0,0,4.517-6.607c1.375-2.788,2.451-7.986,3.109-15.032.534-5.686.69-11.531.663-14.809a3.952,3.952,0,0,1,1.141-2.823,3.951,3.951,0,0,1,2.8-1.189h.036a3.955,3.955,0,0,1,2.8,1.152,3.961,3.961,0,0,1,1.178,2.793c.008,1.061.021,6.692-.5,13.407-.724,9.255-2.1,15.991-4.09,20.022a48.926,48.926,0,0,1-5.362,7.959c-2.437,3.152-4.52,5.967-5.332,8.514a6.957,6.957,0,0,0-.21,3.758l-1.912.622a8.856,8.856,0,0,1,.217-4.985c.908-2.852,3-5.7,5.651-9.128a47.39,47.39,0,0,0,5.156-7.625c1.85-3.749,3.195-10.421,3.888-19.293.55-7.045.5-12.985.5-13.234a1.958,1.958,0,0,0-.585-1.388,1.968,1.968,0,0,0-1.392-.572h-.022a1.96,1.96,0,0,0-1.39.591,1.964,1.964,0,0,0-.567,1.4c.029,3.318-.129,9.241-.671,15.014-.691,7.389-1.8,12.681-3.307,15.729a44.006,44.006,0,0,1-4.716,6.932l-.014.018,0,0c-2.422,3.134-5.167,6.686-6.373,10.535a12.478,12.478,0,0,0-.479,5.875,12.154,12.154,0,0,0,.307,1.36l-1.9.618Z",
    transform: "translate(6417.186 5425)",
    fill: "#4c5b77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_478",
    "data-name": "Path 478",
    transform: "matrix(0.921, -0.391, 0.391, 0.921, 5.278, 21.769)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,47.489.905l5.244,11.62L3.857,12.468Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.728416442871094 2.052388191223145 L 5.332386016845703 10.469895362854 L 49.63412475585938 10.52147102355957 L 46.18623352050781 2.880969047546387 L 2.728416442871094 2.052388191223145 M 0 0 L 47.48896026611328 0.9054403305053711 L 52.73249816894531 12.52508068084717 L 3.857048034667969 12.46818065643311 L 0 0 Z",
    stroke: "none",
    fill: "#4c5b77"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M.024,21.275c-.39,2.039,4.087,27.186,7.683,33.1s5.876,7.43,5.876,7.43L23.2,75v3.839l7.429,5.484s-.327,4.061,2.959,5.107a9.57,9.57,0,0,0,9.387-2.042c2.421-2.293,2.677-3.209,2.874-5.384a44.318,44.318,0,0,0,0-5.366L50,75l1.775-6.345,4.261-20.481,5.325-2.616A51.753,51.753,0,0,0,63.89,31.62c.168-7.18.847-13.327,0-16.934S48.822,0,48.822,0L1.2,19.456S.414,19.236.024,21.275Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#4c5b77",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M0,6.952l12.143,14.21L63,0",
    transform: "translate(0.65 14.806)",
    fill: "none",
    stroke: "#4c5b77",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M0,0,3.3,29.07",
    transform: "translate(12.879 36.101)",
    fill: "none",
    stroke: "#4c5b77",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M0,0A46.328,46.328,0,0,1,6.77,25.426",
    transform: "translate(23.911 58.498)",
    fill: "none",
    stroke: "#4c5b77",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_971",
    "data-name": "Group 971",
    transform: "translate(7.163 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_469",
    "data-name": "Path 469",
    transform: "translate(0 16.17) rotate(-22)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 33.90524673461914 19.47168350219727 L 5.92952299118042 19.25695419311523 L 5.92568302154541 19.25692367553711 L 5.9218430519104 19.25692367553711 C 4.041113376617432 19.25692367553711 1.74375319480896 17.78309440612793 1.74375319480896 16.06298446655273 L 1.74375319480896 15.9825439453125 L 1.730893135070801 15.90314388275146 L 1.001899123191833 11.40096473693848 C 1.025991439819336 10.93489933013916 1.302066802978516 9.480484962463379 3.085023164749146 5.239003658294678 C 3.782102823257446 3.580719709396362 4.484782218933105 2.03394079208374 4.887565612792969 1.162141799926758 L 37.64696502685547 8.984973907470703 L 37.76149368286133 9.012323379516602 L 37.87923431396484 9.012323379516602 C 37.95429229736328 9.012323379516602 38.02780151367188 9.012033462524414 38.09960174560547 9.011743545532227 C 38.16555404663086 9.011483192443848 38.23001480102539 9.011223793029785 38.29285430908203 9.011223793029785 C 38.42272186279297 9.011223793029785 38.78264617919922 9.011220932006836 38.9536247253418 9.045886993408203 C 38.98588562011719 9.194121360778809 39.02408981323242 9.639232635498047 38.79716491699219 10.80026340484619 C 38.56274032592773 11.99963760375977 38.10185623168945 13.72933387756348 37.3042106628418 16.40264320373535 C 36.68514251708984 17.75959777832031 36.2313346862793 18.62763214111328 35.75987243652344 19.04061317443848 C 35.44107437133789 19.31987571716309 35.05082321166992 19.47134971618652 33.90524673461914 19.47168350219727 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.454334259033203 2.325597763061523 C 5.057949066162109 3.197294235229492 4.534442901611328 4.372102737426758 4.013343811035156 5.611164093017578 C 2.330883026123047 9.611705780029297 2.053459167480469 10.98807621002197 2.008518218994141 11.36135959625244 L 2.743751525878906 15.90211296081543 L 2.743751525878906 16.06298446655273 C 2.743751525878906 17.06768417358398 4.466453552246094 18.25692367553711 5.921844482421875 18.25692367553711 L 5.93719482421875 18.25698471069336 L 33.90877914428711 18.47168159484863 C 34.89240264892578 18.47107887268066 35.03321075439453 18.34774780273438 35.1009521484375 18.28840446472168 C 35.48647308349609 17.95070457458496 36.05327987670898 16.73549652099609 36.3656005859375 16.05086517333984 C 37.03972625732422 13.78881549835205 37.47002029418945 12.20628261566162 37.71795272827148 11.0778341293335 C 37.8174934387207 10.62479305267334 37.87988662719727 10.27694034576416 37.91853713989258 10.01229953765869 C 37.90548324584961 10.01231479644775 37.89237976074219 10.0123233795166 37.87923431396484 10.0123233795166 L 37.64374160766602 10.0123233795166 L 5.454334259033203 2.325597763061523 M 4.326324462890625 3.814697265625e-06 L 37.87923431396484 8.012323379516602 C 40.23483657836914 8.012332916259766 40.94214248657227 7.717724800109863 38.24276351928711 16.75456428527832 C 36.81150436401367 19.90045356750488 36.25716400146484 20.47168350219727 33.90155410766602 20.47168350219727 L 5.921844482421875 20.25692367553711 C 3.566234588623047 20.25692367553711 0.7437515258789062 18.41859436035156 0.7437515258789062 16.06298446655273 L 3.814697265625e-06 11.4696741104126 C 3.814697265625e-06 9.114063262939453 4.326324462890625 3.814697265625e-06 4.326324462890625 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#4c5b77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_468",
    "data-name": "Path 468",
    transform: "translate(2.938 13.521) rotate(-22)",
    fill: "#fff",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.169637203216553 12.27984046936035 C 5.601875782012939 12.27975559234619 4.491259574890137 11.58227062225342 3.229456901550293 9.616761207580566 C 2.171796798706055 7.969251155853271 1.330426812171936 5.910261154174805 1.085966825485229 4.371231079101562 C 0.8920767903327942 3.150570869445801 1.022276759147644 2.263970851898193 1.472946763038635 1.736070990562439 C 1.889906764030457 1.247650980949402 2.646886825561523 1.000000953674316 3.722856760025024 1.000000953674316 C 3.873546838760376 1.000000953674316 4.032006740570068 1.005060911178589 4.193856716156006 1.015040993690491 L 4.214056968688965 1.016280889511108 L 4.234296798706055 1.016710996627808 L 28.3696174621582 1.525710940361023 L 28.38015747070312 1.525931000709534 L 28.39069747924805 1.525931000709534 C 28.96872711181641 1.525931000709534 30.25612640380859 2.288750886917114 31.98202705383301 4.438611030578613 C 33.31177520751953 6.095000743865967 34.52823638916016 8.132411003112793 34.94022750854492 9.393211364746094 C 35.18419647216797 10.13980102539062 35.13897705078125 10.75127124786377 34.80581665039062 11.2106409072876 C 34.35883712768555 11.82694053649902 33.39501571655273 12.19488048553467 32.22759628295898 12.19488048553467 L 26.72945594787598 12.21281051635742 L 6.169637203216553 12.27984046936035 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.722858428955078 2.000000953674316 C 2.985404968261719 2.000000953674316 2.442558288574219 2.140450477600098 2.233497619628906 2.385340690612793 C 1.995697021484375 2.663901329040527 1.935916900634766 3.347640991210938 2.073585510253906 4.214350700378418 C 2.287117004394531 5.558650970458984 3.027656555175781 7.398281097412109 3.960197448730469 8.901021003723145 C 5.006826400756836 10.58759307861328 5.903507232666016 11.22825527191162 6.183387756347656 11.27978515625 L 32.22107696533203 11.19489097595215 C 32.22324752807617 11.19488143920898 32.22542572021484 11.19488143920898 32.22759628295898 11.19488143920898 C 33.16315841674805 11.19488143920898 33.79004669189453 10.90792083740234 33.99630737304688 10.62353134155273 C 34.13075637817383 10.43814086914062 34.12853622436523 10.12871074676514 33.98968505859375 9.703821182250977 C 33.68667602539062 8.776510238647461 32.67993545532227 6.945750713348389 31.34208679199219 5.240860939025879 C 29.71785926818848 3.171023368835449 28.63557624816895 2.577262878417969 28.36723136901855 2.525793075561523 C 28.36099815368652 2.525720596313477 28.35476303100586 2.525619506835938 28.34852600097656 2.525490760803223 L 4.213207244873047 2.016490936279297 C 4.18621826171875 2.015920639038086 4.159236907958984 2.014801025390625 4.132286071777344 2.013140678405762 C 3.990898132324219 2.004421234130859 3.853145599365234 2.000000953674316 3.722858428955078 2.000000953674316 M 3.722862243652344 2.86102294921875e-06 C 3.895275115966797 2.86102294921875e-06 4.072765350341797 0.005674362182617187 4.255374908447266 0.01693058013916016 L 28.39069747924805 0.5259313583374023 C 30.91110610961914 0.5259313583374023 35.02662658691406 6.438130855560303 35.89076614379883 9.082601547241211 C 36.75491714477539 11.72708129882812 34.74800872802734 13.19488048553467 32.22759628295898 13.19488048553467 L 6.169767379760742 13.27984046936035 C 3.649368286132812 13.27984046936035 0.6290969848632812 7.869491100311279 0.09834671020507812 4.528100967407227 C -0.4004936218261719 1.387594223022461 1.027454376220703 2.86102294921875e-06 3.722862243652344 2.86102294921875e-06 Z",
    stroke: "none",
    fill: "#4c5b77"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M23.348.53s-1.14-1.192-5.29,0S0,7.259,0,7.259",
    transform: "translate(9.629 12.882)",
    fill: "none",
    stroke: "#4c5b77",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_471",
    "data-name": "Path 471",
    transform: "translate(21.296 12.187)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.071135997772217 6.661374092102051 L 1.00003445148468 1.2401202917099 C 1.002130508422852 1.107365965843201 1.110769391059875 0.9999988079071045 1.244013547897339 0.9999988079071045 C 1.378563642501831 0.9999988079071045 1.488033652305603 1.109468817710876 1.488033652305603 1.244018793106079 L 1.488033652305603 1.251708745956421 L 1.488153576850891 1.259408831596375 L 1.568145871162415 6.457834243774414 L 1.071135997772217 6.661374092102051 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.244013547897339 -9.5367431640625e-07 C 1.931063652038574 -9.5367431640625e-07 2.488033533096313 0.5569686889648438 2.488033533096313 1.2440185546875 L 2.578523635864258 7.124658584594727 L 0.09049367904663086 8.14357852935791 L 3.576278686523438e-06 1.2440185546875 C 3.576278686523438e-06 0.5569686889648438 0.5569636821746826 -9.5367431640625e-07 1.244013547897339 -9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#4c5b77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_474",
    "data-name": "Path 474",
    transform: "translate(26.272 10.318)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.006162643432617 6.539759635925293 L 0.9999991655349731 1.224891424179077 C 0.9999991655349731 1.101411461830139 1.109469175338745 1.000001430511475 1.244019150733948 1.000001430511475 C 1.37856912612915 1.000001430511475 1.4880291223526 1.101411461830139 1.4880291223526 1.226051449775696 L 1.494998574256897 6.342460155487061 L 1.006162643432617 6.539759635925293 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.244019150733948 9.5367431640625e-07 C 1.931069135665894 9.5367431640625e-07 2.48802924156189 0.5489215850830078 2.48802924156189 1.226051330566406 L 2.495919227600098 7.016861438751221 L 0.007879018783569336 8.021061897277832 L -9.5367431640625e-07 1.226051330566406 C -9.5367431640625e-07 0.5489215850830078 0.556969165802002 9.5367431640625e-07 1.244019150733948 9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#4c5b77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_475",
    "data-name": "Path 475",
    transform: "translate(31.915 11.117)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.036699533462524 3.368766069412231 L 1.00005829334259 1.221127390861511 C 1.002892136573792 1.098748683929443 1.111244916915894 1.000003933906555 1.244021058082581 1.000003933906555 C 1.378571033477783 1.000003933906555 1.488031029701233 1.101403832435608 1.488031029701233 1.226043820381165 L 1.488031029701233 1.23785388469696 L 1.488311052322388 1.249663829803467 L 1.533635258674622 3.168196678161621 L 1.036699533462524 3.368766069412231 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.244021058082581 3.814697265625e-06 C 1.931071043014526 3.814697265625e-06 2.488031148910522 0.5489239692687988 2.488031148910522 1.226043939590454 L 2.549700975418091 3.836483955383301 L 0.06167101860046387 4.840683937072754 L 1.192092895507812e-06 1.226043939590454 C 1.192092895507812e-06 0.5489239692687988 0.5569610595703125 3.814697265625e-06 1.244021058082581 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#4c5b77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_472",
    "data-name": "Path 472",
    transform: "translate(15.964 14.497)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.016472935676575 6.533605098724365 L 1.000004053115845 1.240904808044434 C 1.000004053115845 1.109464764595032 1.109464049339294 1.000004768371582 1.244014024734497 1.000004768371582 C 1.3785640001297 1.000004768371582 1.488034009933472 1.109464764595032 1.488034009933472 1.244014859199524 L 1.506667137145996 6.33285665512085 L 1.016472935676575 6.533605098724365 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.244014024734497 4.76837158203125e-06 C 1.931064128875732 4.76837158203125e-06 2.488034009933472 0.5569648742675781 2.488034009933472 1.244014739990234 L 2.509124040603638 7.002924919128418 L 0.02109408378601074 8.021844863891602 L 4.053115844726562e-06 1.244014739990234 C 4.053115844726562e-06 0.5569648742675781 0.5569640398025513 4.76837158203125e-06 1.244014024734497 4.76837158203125e-06 Z",
    stroke: "none",
    fill: "#4c5b77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_473",
    "data-name": "Path 473",
    transform: "translate(11.343 16.012)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.361684203147888 6.610644340515137 C 1.258615255355835 6.610644340515137 1.136085391044617 6.590032577514648 1.013208627700806 6.55987024307251 L 1.000004172325134 1.24153459072113 C 1.000004172325134 1.109464526176453 1.109464168548584 1.000004529953003 1.244014143943787 1.000004529953003 C 1.378564119338989 1.000004529953003 1.488034129142761 1.109464526176453 1.488034129142761 1.244014501571655 L 1.488034129142761 1.250964522361755 L 1.488134145736694 1.257914543151855 L 1.562353491783142 6.59634256362915 C 1.495324611663818 6.605291843414307 1.427607774734497 6.610644340515137 1.361684203147888 6.610644340515137 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.244014143943787 4.76837158203125e-06 C 1.931064128875732 4.76837158203125e-06 2.488034248352051 0.5569643974304199 2.488034248352051 1.244014739990234 L 2.572864055633545 7.345644474029541 C 2.572864055633545 7.345644474029541 1.983694195747375 7.610644340515137 1.361684203147888 7.610644340515137 C 0.7396842241287231 7.610644340515137 0.0149540901184082 7.265374660491943 0.0149540901184082 7.265374660491943 L 4.291534423828125e-06 1.244014739990234 C 4.291534423828125e-06 0.5569643974304199 0.5569641590118408 4.76837158203125e-06 1.244014143943787 4.76837158203125e-06 Z",
    stroke: "none",
    fill: "#4c5b77"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_987",
    "data-name": "Group 987",
    transform: "translate(81.587 40.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_975",
    "data-name": "Group 975",
    transform: "translate(30.164 17.629) rotate(-163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487-2",
    "data-name": "Path 487",
    d: "M5.274,12,0,4.694,8.052,0",
    transform: "translate(0 4.147) rotate(-31)",
    fill: "none",
    stroke: "#2681c1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M17670.93,5058.825s1.172-10.037,12.512-12.22,17.621-2.067,17.621-2.067",
    transform: "translate(-17670.93 -5035.526)",
    fill: "none",
    stroke: "#2681c1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGwConnectionInstructions);
export default __webpack_public_path__ + "static/media/gw_connection_instructions.2395f6fa4917d5c9c06f22723b69bec2.svg";
export { ForwardRef as ReactComponent };